export type ServiceModeType = 'local' | 'remote';

export interface SidecarStatusData {
  status: 'idle' | 'starting' | 'running' | 'stopping' | 'stopped' | 'error';
  data?: { pid?: number; message?: string; exit_code?: number | null };
}

export interface ServiceModeConfig {
  mode: ServiceModeType;
  serverAddress: string;
  localPort: number;
  lastUpdated: string;
}

export const DEFAULT_SERVICE_MODE_CONFIG: ServiceModeConfig = {
  mode: 'local',
  serverAddress: 'http://localhost:3000',
  localPort: 3000,
  lastUpdated: new Date().toISOString(),
};

export function isTauri(): boolean {
  return '__TAURI_INTERNALS__' in window;
}
